export const stands = ['dev', 'test', 'prod'] as const;

export type Stand = (typeof stands)[number];

export function isStand(value: unknown): value is Stand {
  return stands.includes(value as Stand);
}
